<template>
  <L1 :popup="deleteItem">
    <template slot="slot_title">
      <RT :options="['網站', 'POS', '手機']" :defaultValue="source" @input="source=$event"/>
      <RT :options="['角色', '群組', '員工']" :defaultValue="page" @input="page=$event;role=null;staff=null;tag=null;editTag=false"/>
      <div v-if="staff" class="staffInfo">
        <div>{{staff.name}}</div>
        <div class="admin" :class="staff.role">{{rolenames[staff.role]}}</div>
        <div class="title_tags">
          <div v-for="(t, k) in (staff.innerTag || [])" class="title_tag" :key="`tr-${k}`" :title="'刪除'">{{t}}
            <button class="closebtn" @click="deleteItem=t"></button>
          </div>
            <button v-if="!editTag" class="title_tag" @click="editTag=true">+ 新增標籤</button>
          <div v-if="editTag" class="editTag">
            <label for="editTag">
              <input type="text" v-model="innerTag" id="editTag" list="editTagList" :style="{height: '50px'}">
              <datalist id="editTagList">
                <option v-for="(t, k) in tags" :key="`tag-opt-${k}`">{{t}}</option>
              </datalist>
            </label>
            <button class="title_tag" @click="saveTag">儲存標籤</button>
            <button class="title_tag" :style="{backgroundColor: '#CACACA'}" @click="editTag=null;innerTag=null">取消</button>
          </div>
        </div>
      </div>
      <SaveBtn :style="{marginLeft: 'auto'}" v-if="changed" @click="save"/>
    </template>
    <div class="permissionContainer">
      <div class="cates" v-if="page==='角色'">
        <div>角色</div>
        <ul>
          <li v-for="({key, zh}, k) in rolemapInner" :key="`role-${k}`"
          @click="role=key" :class="role===key ? 'selected' : ''">{{zh}}</li>
        </ul>
      </div>
      <div class="cates" v-else-if="page==='群組'">
        <div>群組</div>
        <ul>
          <li v-for="(t, k) in tags" :key="`tag-${k}`"
          @click="tag=t" :class="tag===t ? 'selected' : ''">{{t}}</li>
        </ul>
      </div>
      <div class="cates" v-else>
        <div>員工</div>
        <ul v-for="(Key, k) in Object.keys(departments)" :key="`d-${k}`">
          <li>{{Key}}</li>
          <li v-for="(li, l) in departments[Key]" :key="`d-${l}`" :class="staff?._id===li._id ? 'selected' : ''">
            <div :style="{paddingLeft: '60px'}" @click="staff=li">{{li.name}}
              <span class="admin" v-if="li.role==='admin'">系統管理員</span>
              <span class="admin manager" v-if="li.role==='manager'">主管</span>
              <span class="admin employee" v-if="li.role==='employee'">工作同仁</span>
            </div>
            <!-- <div :style="{marginLeft: 'auto'}">{{li.path}}</div> -->
          </li>
        </ul>
      </div>
      <template v-if="source==='網站'">
      <div v-for="(cate, c) in Object.keys(linksGroup)" :key="`g-${c}`" class="cates">
        <div class="cate">{{cate}}
          <button :style="{marginLeft: 'auto'}"
          @click="permissionUpdate=Array.from(new Set([...permissionUpdate, ...linksGroup[cate].map(e => e.name)]))">全選</button>
          <button @click="permissionUpdate=permissionUpdate.filter(e => !linksGroup[cate].map(e => e.name).includes(e))">全不選</button>
        </div>
        <ul>
          <li v-for="(li, l) in linksGroup[cate]" :key="`l1-${l}`">
            <input type="checkbox" :value="li.name" v-model="permissionUpdate"
            :disabled="myRole!=='admin'||permissionOther.includes(li.name)">
            <div>{{li.title}}</div>
            <!-- <div :style="{marginLeft: 'auto'}">{{li.path}}</div> -->
          </li>
        </ul>
      </div>
      </template>
      <div class="cates" v-else>
        <div class="cate">{{source}}
          <button :style="{marginLeft: 'auto'}"
          @click="permissionUpdate=Array.from(new Set([...permissionUpdate, ...poslinks.map(e => e.name)]))">全選</button>
          <button @click="permissionUpdate=permissionUpdate.filter(e => !poslinks.map(e => e.name).includes(e))">全不選</button>
        </div>
        <ul>
          <li v-for="(li, l) in poslinks" :key="`poslink-${l}`">
            <input type="checkbox" :value="li.name" v-model="permissionUpdate"
            :disabled="myRole!=='admin'||permissionOther.includes(li.name)">
            <div>{{li.title}}</div>
            <!-- <div :style="{marginLeft: 'auto'}">{{li.path}}</div> -->
          </li>
        </ul>
      </div>
    </div>
    <dialognoPadding2 slot="popup" :transparent="true" :label="'確認刪除'" @close="deleteItem=null"
    v-if="deleteItem" :show="deleteItem" :width="600">
      <div :style="{height: '150px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', justifyContent:'center'}">
        <p :style="{fontSize: '24px'}">確定要刪除標籤"{{deleteItem}}"嗎?</p>
        <BtnsS @cancel="deleteItem=null" :save="'確定'" @save="removeTag(deleteItem)"/>
      </div>
    </dialognoPadding2>
  </L1>
</template>

<script>
import { getapi, postapi } from '../store/fetch'
import L1 from '../components/layout/L1.vue'
import RT from '../components/radio/r1.vue'
import SaveBtn from '../components/btn/save.vue'
import dialognoPadding2 from '../components/dialognoPadding2.vue'
import { mapState } from 'vuex'
export default {
  components: { L1, RT, SaveBtn, dialognoPadding2 },
  data () {
    return {
      departments: [],
      department: null,
      staff: null,
      permission: null,
      permissionUpdate: null,
      permissionOther: [],
      page: '角色',
      role: null,
      tag: null,
      editTag: false,
      innerTag: null,
      source: '網站',
      poslinks: [],
      deleteItem: null
    }
  },
  async mounted () {
    const r = await getapi('users/permission')
    this.departments = r.departments
    this.tags = r.tags
    this.poslinks = await getapi(`permission/${this.sourceEn}`)
  },
  watch: {
    async sourceEn () {
      if (this.source !== '網站') this.poslinks = await getapi(`permission/${this.sourceEn}`)
      await this.getx()
    },
    async role () { await this.getx() },
    async tag () { await this.getx() },
    async staff () { await this.getx() }
  },
  computed: {
    ...mapState({
      rolemap: 'rolemap'
    }),
    sourceEn () {
      switch (this.source) {
        case '手機':
          return 'bot'
        case 'POS':
          return 'pos'
        default:
          return 'web'
      }
    },
    changed () {
      const pU = JSON.parse(JSON.stringify(this.permissionUpdate || []))
      const p = JSON.parse(JSON.stringify(this.permission || []))
      pU.sort((a, b) => a.localeCompare(b))
      p.sort((a, b) => a.localeCompare(b))
      return pU.join('|') !== p.join('|')
    },
    myRole () {
      return this.$store.getters.myRole
    },
    rolemapInner () {
      return this.rolemap.filter(e => e.type === 'inner').filter(e => e.key !== 'admin')
    },
    rolenames () {
      return Object.assign({}, ...this.rolemap.map(e => { return { [e.key]: e.zh } }))
    },
    links () {
      return (this.$router.options.routes.find(e => e.name === 'LoggedIn'))
        .children
        .filter(e => e.meta.requiresAuth)
        .filter(e => e.meta.category)
        .filter(e => e.meta.production)
        .filter(e => e.meta.title !== '首頁')
        .map(e => {
          return { ...e, title: e.meta.title, roles: e.meta.role }
        })
    },
    linksGroup () {
      const cates = ['營運服務', '會員專區', '出勤/統計', '設定']
      return Object.assign({}, ...cates.map(cate => {
        const links = this.links.filter(e => e.meta.category === cate)
        return { [cate]: links }
      }))
    }
  },
  methods: {
    clear () {
      this.permission = []
      this.permissionUpdate = []
      this.permissionOther = []
    },
    async getx () {
      if (this.page === '角色') {
        if (!this.role) return this.clear()
        const data = await getapi(`permission/${this.sourceEn}/roles/${this.role}`)
        this.permission = data.roles
        this.permissionUpdate = data.roles
        this.permissionOther = []
      } else if (this.page === '群組') {
        if (!this.tag) return this.clear()
        const dataO = await getapi(`permission/${this.sourceEn}/roles/employee`)
        this.permissionOther = dataO.roles
        const data = await getapi(`permission/${this.sourceEn}/tags/${this.tag}`)
        this.permission = Array.from(new Set([...data.tags, ...dataO.roles]))
        this.permissionUpdate = Array.from(new Set([...data.tags, ...dataO.roles]))
      } else if (this.page === '員工') {
        if (!this.staff) return this.clear()
        const data = await getapi(`permission/${this.sourceEn}/users/${this.staff._id}`)
        this.permission = Array.from(new Set([...data.users, ...data.other]))
        this.permissionUpdate = Array.from(new Set([...data.users, ...data.other]))
        this.permissionOther = data.other
      }
    },
    async getusers () {
      const r = await getapi('users/permission')
      this.departments = r.departments
      this.tags = r.tags
    },
    async save () {
      let r
      if (this.page === '角色') {
        r = await postapi(`permission/${this.sourceEn}/roles/${this.role}`, { names: this.permissionUpdate })
        this.permission = r.roles
        this.permissionUpdate = r.roles
        this.permissionOther = []
      } else if (this.page === '群組') {
        r = await postapi(`permission/${this.sourceEn}/tags/${this.tag}`, { names: this.permissionUpdate.filter(e => !this.permissionOther.includes(e)) })
        this.permission = Array.from(new Set([...this.permissionOther, ...r.tags]))
        this.permissionUpdate = Array.from(new Set([...this.permissionOther, ...r.tags]))
      } else if (this.page === '員工') {
        r = await postapi(`permission/${this.sourceEn}/users/${this.staff._id}`, { names: this.permissionUpdate.filter(e => !this.permissionOther.includes(e)) })
        this.permission = Array.from(new Set([...r.users, ...r.other]))
        this.permissionUpdate = Array.from(new Set([...r.users, ...r.other]))
        this.permissionOther = r.other
      }
    },
    async saveTag () {
      if (this.innerTag) {
        await postapi(`users/innerTag/${this.staff._id}`, { type: 'add', innerTag: this.innerTag })
        this.innerTag = null
        this.editTag = false
        await this.getusers()
        this.staff = [].concat(...Object.values(this.departments)).find(e => e._id === this.staff._id)
      }
    },
    async removeTag (tag) {
      await postapi(`users/innerTag/${this.staff._id}`, { type: 'remove', innerTag: tag })
      this.innerTag = null
      this.editTag = false
      await this.getusers()
      this.staff = [].concat(...Object.values(this.departments)).find(e => e._id === this.staff._id)
      this.deleteItem = null
    }
  }

}
</script>

<style lang="scss" scoped>
.editTag {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  button {
    height: 50px;
    font-size: 20px!important;
  }
}
.closebtn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  width: 14px;
  height: 14px;
  mask-image: url(/svg/btn/close.svg);
  mask-size: 10px;
  mask-repeat: no-repeat;
  mask-position: center;
  border: 2px solid #FFFFFF;
  background-color: #FFFFFF;
}
.staffInfo {
  display: flex;
  align-items: flex-end;
  margin-left: 40px;
  font-size: 20px;
  &>div:nth-child(1) {
    font-size: 24px;
  }
  .title_tags {
    margin-left: 20px;
    display: flex;
    gap: 10px;
    input[type=text] {
      border: 1px solid #CACACA;
      margin-left: 20px;
      border-radius: 3px;
      padding-inline: 1em;
      &::-webkit-calendar-picker-indicator {
        opacity: 100;
        font-size: 17px;
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
      }
    }
  }
  .title_tag {
    font-size: 14px;
    padding: .2em .5em;
    background-color: var(--color-number-2);
    color: #FFFFFF;
    border-radius: 3px;
    letter-spacing: .05em;
    display: flex;
    align-items: center;
    justify-content: center;
    &>button {
      display: none;
    }
    &:hover>button {
      display: flex;
    }
  }
}
.admin {
  font-size: 14px;
  padding: .2em .5em;
  background-color: var(--highlight);
  color: #FFFFFF;
  margin-left: 20px;
  border-radius: 3px;
  letter-spacing: .05em;
  &.employee {
    background-color: var(--color-infobox);
    color: var(--color-checked);
  }
  &.manager {
    background-color: var(--color-checked);
  }
}
.permissionContainer {
  display: grid;
  grid-template-columns: 1.2fr repeat(4, 1fr);
  height: calc(100vh - 90px);
}
.cates {
  border-right: 1px solid #CACACA;
  padding-bottom: 50vh;
  max-height: calc(100vh - 90px);
  overflow-y: auto;
  &>:nth-child(1) {
    background-color: var(--color-pri);
    color: #FFFFFF;
    padding: 10px 20px;
    font-size: 22px;
    letter-spacing: .1em;
    position: sticky;
    top: 0;
  }
  .cate {
    display: flex;
    gap: 10px;
    button {
      padding-inline: .5em;
      border-radius: 3px;
      font-size: 16px;
      background-color: #FFFFFF;
    }
  }
  ul {
    // display: grid;
    // grid-template-columns: repeat(5, 1fr);

  }
}
li {
  display: flex;
  gap: 20px;
  padding: 10px 20px;
  font-size: 20px;
  &>:nth-child(1){
    text-align: start;
  }
  &>:last-child {
    text-align: end;
  }
  input[type=checkbox] {
    width: 26px;
    accent-color: var(--color-pri);
  }
  &.selected {
    background-color: var(--color-infobox);
  }
}
</style>
